export default "__VITE_ASSET__VlFfLub3__"